import { useEffect, useState } from "react"
import { MoreVertical } from "react-feather"
import { CardBody } from "reactstrap"
import { Dropdowns } from "../../../AbstractElements"
import FeeUpdate from "./FeeUpdate"
import FeeHistory from "./FeeHistory"
import FeeRefund from "./FeeRefund"
import useFetchUserRoles from "../../../hook"
import { isWriteAccess } from "../../../utils/adminRoles"
import { toast } from "react-toastify"

const FeeAction = ({ data, module, updateStudents, courseStudents, setTotal }) => {
    const [showUpdateFee, setShowUpdateFee] = useState(false)
    const [showFeeHistory, setShowFeeHistory] = useState(false)
    const [actionOptions, setActionOptions] = useState([])
    const [showFeeRefund, setShowFeeRefund] = useState(false)
    const hasAccess = useFetchUserRoles('feemanagement', isWriteAccess)

    const feeUpdateClickHanlder = () => {
        if (hasAccess) {
            setShowUpdateFee(true)
        } else {
            toast.error(
                "You don't have access, please ask Super Admin to provide you access!"
            );
        }
    }

    const items = [{
        item: 'Send Email',
        onClick: () => composeEmail()
    }, {
        item: 'Payment History',
        onClick: () => setShowFeeHistory(true)
    }, {
        item: 'Update Fee',
        onClick: () => feeUpdateClickHanlder()
    }, {
        item: 'Refund Fee',
        onClick: () => setShowFeeRefund(true)
    }, {
        item: 'View Details',
        onClick: () => { }
    }, {
        item: 'Take Action',
        onClick: () => { }
    }]


    const composeEmail = () => {
        const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${data.email}`;
        window.open(url, "_blank");
    };

    useEffect(() => {
        const screenshot = data.courses[data.courseIndex].feeScreenshots[module]
        if (screenshot?.status === 'refunded') {
            setActionOptions(items.filter((action) => action.item !== 'Refund Fee'))
        } else {
            setActionOptions(items)

        }
    }, [hasAccess])


    return (
        <div>
            <CardBody className="dropdown-basic p-0 fee-table-action">
                <Dropdowns
                    attrDropBtn={{ className: 'dropbtn table-action' }}
                    attrDropMenu={{ className: 'dropdown-content module-dropdown' }}
                    dropItem={actionOptions}
                    dropBtnContent={<MoreVertical />}
                    attrDropItem={{
                        toggle: false,
                    }}
                />
            </CardBody>
            {showUpdateFee && <FeeUpdate
                updateStudents={updateStudents}
                courseStudents={courseStudents}
                data={data}
                open={showUpdateFee}
                module={module}
                setOpen={setShowUpdateFee}
            />}
            {showFeeHistory && <FeeHistory
                updateStudents={updateStudents}
                courseStudents={courseStudents}
                data={data}
                open={showFeeHistory}
                module={module}
                setOpen={setShowFeeHistory}
            />}
            {showFeeRefund && <FeeRefund
                updateStudents={updateStudents}
                courseStudents={courseStudents}
                setTotal={setTotal}
                data={data}
                open={showFeeRefund}
                module={module}
                setOpen={setShowFeeRefund}
            />}
        </div>
    )
}

export default FeeAction